module.exports = __webpack_public_path__ + "img/an.58f55c5c.png";